import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Header = styled.div`
  display: flex;
  align-items: flex-end;
  min-height: 35px;
  margin-left: 24px;
  margin-right: 32px;
  border-bottom: 1px solid ${COLORS.line};
`;

export default Header;
